import React from "react";
import ProjectStateBadge from "../ProjectStateBadge.tsx";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {useProject} from "../../hooks/useProject.ts";
import {IStateEnum} from "../../models/enums/state.enum.ts";
import SmartIcon from "../SmartIcon.tsx";
import {LiaEdit} from "react-icons/lia";
import {useOpenSeriesModal} from "../../hooks/useOpenSeriesModal.tsx";
import {formatDuration} from "../../utils/utils.ts";

interface ProjectDrawerOverviewProps {
  project: IProject;
  closeDrawer: () => void;
}

const ProjectDrawerOverview: React.FC<ProjectDrawerOverviewProps> = (
  {
    project,
    closeDrawer
  }: ProjectDrawerOverviewProps) => {
  const openSeriesModal: (seriesId: string) => void = useOpenSeriesModal()
  const {
    getProjectStateEnum,
    getDateStringAtUtcFormat,
  } = useProject()

  const projectState: IStateEnum = getProjectStateEnum(project)

  const editSeries = () => {
    closeDrawer();
    openSeriesModal(project.seriesName);
  }

  return (
    <>
      <div className="flex-1">
        <div className="flex flex-col space-y-4 text-n-300/50 text-sm">
          <div className="flex justify-between">
            <div className="text-base font-semibold">Project Name</div>
            <div className="text-base">{project.name}</div>
          </div>
          <div className="flex justify-between">
            <div className="text-base font-semibold">Series Name</div>
            <div className="flex items-center text-base gap-2">
              <span>{project.seriesName}</span>
              {project.seriesName && (
                <div
                  onClick={editSeries}>
                  <SmartIcon name={LiaEdit} className="h-5 w-5 hover:fill-white cursor-pointer"/>
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-between">
            <div className="text-base font-semibold">Status</div>
            <div><ProjectStateBadge state={projectState} enableTooltip={false}/></div>
          </div>
          <div className="flex justify-between">
            <div className="text-base font-semibold">Duration</div>
            <div>{formatDuration(project.mediaMeta.videoDuration)}</div>
          </div>
          <div className="flex justify-between">
            <div className="text-base font-semibold">Created At</div>
            <div className="text-base">{getDateStringAtUtcFormat(project.createdAt)}</div>
          </div>
          <div className="flex justify-between">
            <div className="text-base font-semibold">Last Updated</div>
            <div className="text-base">{getDateStringAtUtcFormat(project.updatedAt)}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProjectDrawerOverview;